import React from 'react';
export default function Hobbies() {
  return (
      <section>
  <h1>Work in progress
    </h1>
    <h1>I will have each dedicate page for Promo Code Leadership, Sustainability, Books I have read , Basketball, Library Visit, Writing,Podcast, and maybe other stuff that I have been doing but I don't even remember.
    </h1>
     </section>

      );  
};
